import { DashboardResponse } from '../types/Dashboard.types';
import API from './ApiBase';

export const fetchDashboard = async (): Promise<DashboardResponse> => {
  try {
    const response = await API.get('/dashboard');
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || 'Failed to fetch dashboard data'
    );
  }
};
